import {UPDATE_SCORE} from "../actions/action";
import {put, select, takeEvery} from "redux-saga/effects";
import {AnyAction} from "redux";
import * as _ from 'lodash';
import {getEnergyMix} from "../reducers/getEnergyMix";
import {getEnergyOutput, getEnergyOutputRatio} from "../reducers/outputs/energyOutput";
import {getCostPerMw} from "../reducers/outputs/costPerMw";
import {getEnvironmentalImpact} from "../reducers/outputs/environmentalImpact";
import {addScore} from "../actions/score";
import {IYear} from '../../data/data';
import {getYearData} from '../reducers/year';
import {countPowerSourceDifferencesByType, getSavedPowerSourceCounts, PowerSourceCounts} from '../reducers/savedPowerSourceCounts';
import {getCarbonOutput, getCarbonOutputTarget} from '../reducers/outputs/carbonOutput';
import {getDamage} from '../reducers/power-sources/damage';

/**
 * handle game score
 */
export default function* handleScoreUpdates()
{
    yield takeEvery(UPDATE_SCORE, onUpdateScore);
}


/**
 * when the timer triggers a score update
 * @param {AnyAction} action
 */
function* onUpdateScore(action: AnyAction)
{
    //  get KPIs

    // const energy_mix: number = yield select(getEnergyMix);
    // const cost_per_mw: number = yield select(getCostPerMw);
    // const energy_output: number = yield select(getEnergyOutput);
    // const environmental: number = yield select(getEnvironmentalImpact);
    //
    // //  add everything together to get the additional score
    //
    // const score: number = Math.round(energy_mix + cost_per_mw + energy_output + environmental);

    //  get the current year object

    const year: IYear = yield select(getYearData);

    console.group('onUpdateScore');

    const {demand, 'carbon-target':carbon_target, 'add-sources':add_sources, outage} = year;

    let score: number = 0;

    if (add_sources)
    {
        //  has the user added enough of the required source type?

        // const saved_count: PowerSourceCounts = yield select(getSavedPowerSourceCounts);
        const source_changes: PowerSourceCounts = yield select(countPowerSourceDifferencesByType);

        const change: number = source_changes[add_sources];

        if (change > 4) score += 1000;

        console.log('sources score', change > 4);
    }

    if (carbon_target)
    {
        //  has the user met their carbon target for the year?

        const carbon_output: number = yield select(getCarbonOutput);
        const carbon_target: number = yield select(getCarbonOutputTarget);

        if (carbon_output < carbon_target) score += 1000;

        console.log('carbon score', carbon_output < carbon_target ? 1000 : 0);
    }

    if (demand)
    {
        //  has the user met their demand for the year?

        const ratio: number = yield select(getEnergyOutputRatio);

        score += (1 - ratio) * 1000;

        console.log('demand score', ratio, (1 - ratio) * 1000);
    }

    if (outage)
    {
        //  has the user repaired all damaged power stations?

        const damage: boolean[] = yield select(getDamage);

        const damage_count: number = _.reduce(damage, (count: number, damaged: boolean) =>
        {
            count += (damaged === true) ? 1 : 0;

            return count;
        }, 0);

        score -= damage_count * 1000;

        console.log('damage score', damage_count * -1000);
    }

    //TODO  check mini-game output to determine score

    console.log('new score', score);
    console.groupEnd();

    // const score: number = 10;

    //  add more score

    yield put(addScore(score));
}



// WEBPACK FOOTER //
// ./src/ts/store/sagas/handleScore.ts